const release = "fontis.r100-heads-master-0-g8e8f6eb"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

module.exports = {
    release,
}
